export enum ActionTypeEnum {

    DELIVERIES_SACHETS = 'Sobres distribuidos',
    STOCK_ADDICTION = 'Sobres agregados al inventario',
    EDITED_STOCK = 'Edición de inventario manual'

}
